export default "__VITE_ASSET__Cbw3NN_1__"